const prepareCoverImageUrl = (catalog, isRetina) => `https://static.displate.com/brand/layout/${catalog}/catalogCover${isRetina ? 'Retina' : 'Standard'}.jpg`;
export const brandsBannersData = {
    title: 'Featured',
    linkTitle: 'Discover all Brands',
    linkUrl: '/browse-brands',
    banners: [
        {
            url: '/licensed/game-of-thrones',
            alt: 'Game of Thrones GOT',
            imageUrl: prepareCoverImageUrl('23369eeb-8d6b-40dc-a4e4-465d6d14ad50'),
            imageRetinaUrl: prepareCoverImageUrl('23369eeb-8d6b-40dc-a4e4-465d6d14ad50', true),
        },
        {
            url: '/licensed/wizarding-world',
            alt: 'Wizarding World',
            imageUrl: prepareCoverImageUrl('4c191e54-919c-4ec6-bd40-f49a281fb649'),
            imageRetinaUrl: prepareCoverImageUrl('4c191e54-919c-4ec6-bd40-f49a281fb649', true),
        },
        {
            url: '/licensed/nfl-players-association',
            alt: 'NFL Players Association',
            imageUrl: prepareCoverImageUrl('662e03be-067f-4cce-8baa-e14f11b6c45f'),
            imageRetinaUrl: prepareCoverImageUrl('662e03be-067f-4cce-8baa-e14f11b6c45f', true),
        },
        {
            url: '/licensed/rick-and-morty',
            alt: 'Rick and Morty',
            imageUrl: prepareCoverImageUrl('3134386d-c57f-4bb8-882e-6c4aee42dd49'),
            imageRetinaUrl: prepareCoverImageUrl('3134386d-c57f-4bb8-882e-6c4aee42dd49', true),
        },
        {
            url: '/licensed/middleearth',
            alt: 'Middle Earth LOTR Hobbit',
            imageUrl: prepareCoverImageUrl('608d4cbd-3134-458b-87ac-af596840c06d'),
            imageRetinaUrl: prepareCoverImageUrl('608d4cbd-3134-458b-87ac-af596840c06d', true),
        },
    ],
};
//# sourceMappingURL=banners.js.map